import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ProductoService } from 'app/services/producto.service';

@Component({
  selector: 'app-productos-dialogo',
  templateUrl: './productos-dialogo.component.html',
  styleUrls: ['./productos-dialogo.component.css']
})
export class ProductosDialogoComponent implements OnInit {
  displayedColumns: string[] = ['select', 'code', 'name', 'type', 'price', 'status'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  selection = new SelectionModel<any>(true, []);
  productosSeleccionadosPreviamente: any[] = [];
  isLoading = false;
  
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    public dialogRef: MatDialogRef<ProductosDialogoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private productoService: ProductoService
  ) {
    // Si hay productos ya seleccionados, los guardamos para referencia
    if (data && data.productosSeleccionados) {
      this.productosSeleccionadosPreviamente = [...data.productosSeleccionados];
    }
  }

  ngOnInit(): void {
    this.obtenerProductos();
  }

  ngAfterViewInit() {
    if (this.paginator && this.sort) {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    }
  }

  obtenerProductos() {
    this.isLoading = true;
    this.productoService.getVariantesDisponibleVenta().subscribe(
      (data) => {
        this.dataSource.data = data;
        this.isLoading = false;
      },
      error => {
        console.error(error);
        this.isLoading = false;
      }
    );
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // Verificar si un producto ya estaba seleccionado previamente
  estaSeleccionadoPreviamente(producto: any): boolean {
    return this.productosSeleccionadosPreviamente.some(p => p.id === producto.id);
  }

  // Selección masiva
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.filter(row => !this.estaSeleccionadoPreviamente(row)).length;
    return numSelected === numRows;
  }

  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
    } else {
      this.dataSource.data.forEach(row => {
        if (!this.estaSeleccionadoPreviamente(row)) {
          this.selection.select(row);
        }
      });
    }
  }

  toggleRowSelection(producto: any) {
    if (!this.estaSeleccionadoPreviamente(producto)) {
      this.selection.toggle(producto);
    }
  }

  // Obtener clase CSS para el chip de tipo
  getTypeChipClass(type: string): string {
    switch (type?.toLowerCase()) {
      case 'producto':
        return 'type-chip-producto';
      case 'servicio':
        return 'type-chip-servicio';
      case 'insumo':
        return 'type-chip-insumo';
      default:
        return 'type-chip-default';
    }
  }

  // Agregar productos seleccionados
  agregarSeleccionados(): void {
    const productosParaAgregar = this.selection.selected.map(producto => ({
      id: producto.id,
      code: producto.code || producto.id.toString(),
      name: producto.name,
      type: producto.type || 'Producto',
      price: producto.price || 0,
      customPrice: producto.price || 0,
      description: producto.description || ''
    }));

    // Combinamos los productos ya seleccionados con los nuevos
    const todosLosProductos = [...this.productosSeleccionadosPreviamente, ...productosParaAgregar];
    
    this.dialogRef.close(todosLosProductos);
  }

  cancelar(): void {
    this.dialogRef.close();
  }
}

